import React, {useContext, useCallback} from "react";

import Button from "./Button.jsx";

export default ({item, className, onChange, busy}) => {

  const handleChange = useCallback((qty) => {
    if(typeof onChange == "function") onChange(item.key, qty);
  }, [item]);

  return <div>
            <div className={`h-stack justify-center ${className || ''} inline-quantity-selector`}>
              <Button onClick={()=> handleChange(Math.max(0, item.quantity - 1))} disabled={busy}>-</Button>
              <input class="quantity-input" type="text" is="quantity-input" inputmode="numeric" aria-label="Change quantity" defaultValue={item.quantity} onBlur={(event)=>{handleChange(event.currentTarget.value)}}/>
              <Button onClick={()=> handleChange(item.quantity + 1)} disabled={busy}>+</Button>
            </div>
            <div class="pill-loader_container">
              <pill-loader class="pill-loader" aria-busy={busy}></pill-loader>
            </div>
          </div>;
}
